import { Injectable } from '@angular/core';
import { ApolloQueryResult } from '@apollo/client/core';
import {
  BasketAccountsGQL,
  BasketAccountsQuery,
} from '@epicuro-next/data/accounts';
import {
  Account,
  QueryBasketAccountsArgs,
} from 'graphql-api/gql-api-interfaces';
import { Observable, throwError } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

@Injectable()
export class BasketAccountsService {
  constructor(private basketAccountsGQL: BasketAccountsGQL) {}

  /**
   * Get basket accounts
   * @param query
   */
  public getBasketAccounts(
    query: QueryBasketAccountsArgs,
  ): Observable<Account[]> {
    return this.basketAccountsGQL
      .fetch(query, { fetchPolicy: 'no-cache' })
      .pipe(
        take(1),
        map((queryResult: ApolloQueryResult<BasketAccountsQuery>) => {
          return queryResult.data.basketAccounts as Account[];
        }),
        catchError(() =>
          throwError({
            message: `Failed to get basket accounts for ${query.basketId}`,
          }),
        ),
      );
  }

  /**
   * Compare basket accounts and accounts selection
   * @param basketAccounts
   * @param selectedAccounts
   */
  public isEqualAccounts(
    basketAccounts: Account[],
    selectedAccounts: Account[],
  ) {
    if (basketAccounts.length !== selectedAccounts.length) {
      return false;
    }

    return basketAccounts.every((basketAccount) => {
      return selectedAccounts.some((selectedAccount) => {
        return (
          selectedAccount.accountId === basketAccount.accountId &&
          selectedAccount.shipToAddresses.every((basketAddress) => {
            return basketAccount.shipToAddresses.find(
              (accountAddress) =>
                accountAddress.addressId === basketAddress.addressId &&
                accountAddress.hasDeliveryItems ===
                  basketAddress.hasDeliveryItems,
            );
          })
        );
      });
    });
  }
}
